import React from 'react'
import Navigation from 'components/navigation'

export default props =>
  <Navigation currentPath={props.currentPath} />
